import React from 'react';

interface UploadingOverlayProps {
	useGrayOverlay?: boolean;
}

export function UploadingOverlay({useGrayOverlay}: UploadingOverlayProps) {
	return <div className={`uploading-overlay-container loading${useGrayOverlay ? ' gray-background' : ''}`} />;
}
